export const BACKEND_URL = 'https://api3.insightmonk.com';
export const BACKEND_URL_MAIN = 'https://api2.insightmonk.com';
export const COMMUNITY_URL = "https://community-api.insightmonk.com";



// WEBPACK FOOTER //
// ./src/config.js